import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { useDispatch } from 'react-redux'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import MyButton from '../../../../UI/form/MyButton'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import TextFieldMain from '../../../../form/fields/TextFieldMain'
import { editWriteOfActNumberBasAPI } from '../../../../../api/writeOff/writeOffActAPI'
import { setWriteOffAct } from '../../../../../store/writeOffSlice'

const ChangeNumberBasForm = ({ writeOffActBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(
        writeOffActBd ? 
            {
                numberBas: writeOffActBd.numberBas,
            } 
        : {}
    ) // Дані з форми

    // console.log('data', data)
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = getDataForBd()

        setError('')
        setLoading(true)

        editWriteOfActNumberBasAPI(dataForBd).then(data => {
            if (data) {
                dispatch(setWriteOffAct(data))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const getDataForBd = () => {
        const dataForBd = {
            id: writeOffActBd.id,
            numberBas: data.numberBas,
        }

        return dataForBd
    }


  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('numberBas', 'writeOffAct') ?
				<TextFieldMain
					required={formDataProductRequiredField('numberBas', 'writeOffAct')}
					setValidate={e => updateValidate(setValid, 'numberBas', e)}
					setValueForm={e => setValueForm(setData, 'numberBas', e)}
					forciblyValue={data && data.numberBas ? data.numberBas : ''}
                    label='Номер з БАС'
                    placeholder='Введіть номер'
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default ChangeNumberBasForm